























import { defineComponent } from "@nuxtjs/composition-api";
import CouponItem from "~/components/JetUi/molecules/Coupon/CouponItem.vue";

export default defineComponent({
  name: "CouponsPage",
  components: {
    CouponItem,
  },
  setup() {
    const couponItems = [
      {
        imgDsk: "/banners/coupons/2.png",
        imgMob: "/banners/coupons/2.png",
        title: "Home Office",
        discount: 10,
        coupon: "HOME10",
        footer:
          'Utilize o cupom "HOME10" e ganhe 10% de desconto em produtos selecionados para compor um bom home office, podendo utilizar em produtos de todas as categorias.',
        primary: "#142D7A",
        secondary: "#5BC0BE",
        colorText: "white",
      },
      {
        imgDsk: "/banners/coupons/3.png",
        imgMob: "/banners/coupons/3.png",
        title: "INFORMÁTICA",
        discount: 5,
        coupon: "INFO5",
        footer:
          'Utilize o cupom "INFO5" e ganhe 5% de desconto em produtos da categoria de informática.',
        primary: "#4EA8AA",
        secondary: "#242223",
        colorText: "white",
      },
      {
        imgDsk: "/banners/coupons/4.png",
        imgMob: "/banners/coupons/4.png",
        title: "LIMPEZA",
        discount: 10,
        coupon: "LIMP10",
        footer:
          'Utilize o cupom "LIMP10" e ganhe 10% de desconto em produtos da categoria de limpeza.',
        secondary: "#00264F",
        primary: "#267AB1",
        colorText: "white",
      },
      {
        imgDsk: "/banners/coupons/5.png",
        imgMob: "/banners/coupons/5.png",
        title: "Flash Limp",
        discount: 10,
        coupon: "FLASH10",
        footer:
          'Utilize o cupom "FLASH10"  e ganhe 10% de desconto em produtos da marca de Flash Limp.',
        secondary: "#70A6C2",
        primary: "#17537A",
        colorText: "white",
      },
    ];
    return {
      couponItems,
    };
  },
  head() {
    return {
      title: this.$t("Coupons").toString(),
    };
  },
});
